import style from "./style.module.css";

interface GradientLineProps {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

const GradientLine = ({ x1, y1, x2, y2 }: GradientLineProps) => (
  <>
    {/* Shadow line for contrast on light backgrounds */}
    <line x1={x1} y1={y1} x2={x2} y2={y2} className={style.lineShadow} />
    {/* Visible white line */}
    <line x1={x1} y1={y1} x2={x2} y2={y2} className={style.line} />
  </>
);

export default GradientLine;
